import scanOk from '../assets/sounds/scanOk.wav'
import scanDeny from '../assets/sounds/scanDeny.wav'

export const playScanOkSound = () => {
  new Audio(scanOk).play()
}
export const playScanErrorSound = () => {
  new Audio(scanDeny).play()
}